// Google Tag Manager Configuration
export const GTM_ID = 'GTM-M3JN6J2S'; // Replace with your GTM ID

// Analytics Events
export const ANALYTICS_EVENTS = {
  // Basic Events
  BUTTON_CLICK: 'button_click',
  FORM_SUBMIT: 'form_submit',
  PAGE_VIEW: 'page_view',
  
  // Program Related
  PROGRAM_VIEW: 'program_view',
  PROGRAM_ENROLLMENT: 'program_enrollment',
  PROGRAM_COMPLETION: 'program_completion',
  LESSON_START: 'lesson_start',
  LESSON_COMPLETE: 'lesson_complete',
  
  // Engagement Events
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  VIDEO_START: 'video_start',
  VIDEO_COMPLETE: 'video_complete',
  DOWNLOAD_RESOURCE: 'download_resource',
  SHARE_CONTENT: 'share_content',
  
  // User Account
  USER_SIGNUP: 'user_signup',
  USER_LOGIN: 'user_login',
  PROFILE_UPDATE: 'profile_update',
  
  // E-commerce
  VIEW_ITEM: 'view_item',
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  REFUND: 'refund'
};

// Analytics Categories
export const ANALYTICS_CATEGORIES = {
  NAVIGATION: 'navigation',
  ENGAGEMENT: 'engagement',
  CONVERSION: 'conversion',
  CONTENT: 'content',
  ECOMMERCE: 'ecommerce',
  USER: 'user',
  PROGRAM: 'program',
  MENTORSHIP: 'mentorship',
  TECHNICAL: 'technical'
};

// Custom Dimensions
export const CUSTOM_DIMENSIONS = {
  // User Related
  USER_TYPE: 'user_type',
  USER_ROLE: 'user_role',
  USER_SEGMENT: 'user_segment',
  EXPERIENCE_LEVEL: 'experience_level',
  CAREER_STAGE: 'career_stage',
  INDUSTRY: 'industry',
  
  // Program Related
  PROGRAM_NAME: 'program_name',
  PROGRAM_CATEGORY: 'program_category',
  PROGRAM_DIFFICULTY: 'program_difficulty',
  PROGRAM_DURATION: 'program_duration',
  
  // Page Related
  PAGE_SECTION: 'page_section',
  PAGE_TEMPLATE: 'page_template',
  CONTENT_TYPE: 'content_type',
  
  // Technical
  DEVICE_TYPE: 'device_type',
  BROWSER_TYPE: 'browser_type',
  SCREEN_SIZE: 'screen_size'
};

// Event Parameters
export const EVENT_PARAMETERS = {
  // UI Elements
  BUTTON_LABEL: 'button_label',
  SECTION_NAME: 'section_name',
  INTERACTION_TYPE: 'interaction_type',
  SOURCE: 'source',
  
  // E-commerce
  CURRENCY: 'currency',
  PRICE: 'price',
  DISCOUNT_CODE: 'discount_code',
  PAYMENT_METHOD: 'payment_method',
  
  // Content
  CONTENT_TITLE: 'content_title',
  CONTENT_FORMAT: 'content_format',
  CONTENT_CATEGORY: 'content_category',
  
  // User Journey
  FUNNEL_STAGE: 'funnel_stage',
  PREVIOUS_PAGE: 'previous_page',
  NEXT_PAGE: 'next_page'
};

// A/B Testing Configuration
export const AB_TEST_CONFIG = {
  TESTS: {
    HERO_VARIANT: 'hero_variant',
    CTA_COLOR: 'cta_color',
    PRICING_DISPLAY: 'pricing_display',
    PROGRAM_LAYOUT: 'program_layout'
  },
  VARIANTS: {
    A: 'variant_a',
    B: 'variant_b',
    CONTROL: 'control'
  }
};

// User Segments
export const USER_SEGMENTS = {
  NEW_VISITOR: 'new_visitor',
  RETURNING_VISITOR: 'returning_visitor',
  ENROLLED_STUDENT: 'enrolled_student',
  PROGRAM_GRADUATE: 'program_graduate',
  MENTOR: 'mentor',
  CORPORATE_CLIENT: 'corporate_client'
};

// Conversion Goals
export const CONVERSION_GOALS = {
  PRIMARY: {
    PROGRAM_PURCHASE: 'program_purchase',
    FREE_SESSION_BOOKING: 'free_session_booking',
    MENTORSHIP_ENROLLMENT: 'mentorship_enrollment'
  },
  SECONDARY: {
    NEWSLETTER_SIGNUP: 'newsletter_signup',
    RESOURCE_DOWNLOAD: 'resource_download',
    WEBINAR_REGISTRATION: 'webinar_registration'
  },
  MICRO: {
    BLOG_READ: 'blog_read',
    VIDEO_VIEW: 'video_view',
    SOCIAL_SHARE: 'social_share'
  }
};

// E-commerce Config
export const ECOMMERCE_CONFIG = {
  CURRENCY: 'USD',
  TAX_RATE: 0.0,
  PAYMENT_METHODS: ['credit_card', 'paypal', 'bank_transfer'],
  DISCOUNT_TYPES: ['early_bird', 'referral', 'corporate', 'seasonal']
};